import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=57b6345f&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=57b6345f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b6345f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57b6345f')) {
      api.createRecord('57b6345f', component.options)
    } else {
      api.reload('57b6345f', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=57b6345f&scoped=true&", function () {
      api.rerender('57b6345f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CdtCGAoy68A6/JS/teamMember.vue"
export default component.exports